export default "__VITE_ASSET__WdqZu8_v__"